export default {
    // General status codes
    99: "Pending",
    100: "Created",
    200: "Ready",
    300: "Matched",
    // Validation error codes
    400: "Type Too Long",
    401: "Invalid Attendance From Date",
    402: "Invalid Period To Date",
    403: "Invalid Payment Date",
    404: "SWN Too Long",
    405: "Current Week Invalid",
    406: "Previous Week Invalid",
    407: "CCA Hours Invalid",
    408: "Invalid Renewal Date",
    409: "Invalid Type Supplied",
    413: "Invalid Rate",

    // Email processing error codes
    500: "PDF Attachment No Content",
    501: "SWN Number Not Found",
    502: "Failed To Unlock PDF",
    503: "No Entries Found In PDF",
    504: "Errors Found In Entries",
    505: "Grand Total Mismatch",
    506: "Incorrect PDF Password",
    507: "Processing Error",
    // Child Match Error Codes   
    600: "Multiple Name Matches Found",
    601: "Child Match Not Determined",
    602: "No Matches For Child Found",
    603: "Invalid Match Record",
    // Processing error codes
    598: "General Validation Error",
    999: "Unknown Error"
};